import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  collectionData,
  doc,
  docData,
  serverTimestamp,
  setDoc,
  updateDoc
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Landlord } from '../models/landlord.model';

@Injectable({ providedIn: 'root' })
export class LandlordService {
  constructor(private fs: Firestore) {}

  /** ADMIN: Get all landlords */
  getLandlords(): Observable<Landlord[]> {
    return collectionData(
      collection(this.fs, 'landlords'),
      { idField: 'id' }
    ) as Observable<Landlord[]>;
  }

  /** Get single landlord by ID */
  getLandlordById(id: string): Observable<Landlord> {
    return docData(
      doc(this.fs, 'landlords', id),
      { idField: 'landlordId' }
    ) as Observable<Landlord>;
  }

  /** Create landlord (ID is explicit) */
  createLandlord(data: { id: string; name: string }) {
    return setDoc(doc(this.fs, 'landlords', data.id), {
      name: data.name,
      slug: data.id.toLowerCase(),
      status: 'active',
      createdAt: serverTimestamp()
    });
  }

  /** Partial update */
  updateLandlord(id: string, data: Partial<Landlord>) {
    return updateDoc(doc(this.fs, 'landlords', id), {
      ...data,
      updatedAt: serverTimestamp()
    });
  }

  /** Soft archive */
  archiveLandlord(id: string) {
    return updateDoc(doc(this.fs, 'landlords', id), {
      status: 'archived',
      archivedAt: serverTimestamp()
    });
  }
}
